import { makeAutoObservable } from "mobx";
import { SwipeUser } from "../models/api/SwipeUser";
import { ProgStatus } from "../models/utilTypes";
import ApiService from "../services/ApiService";
import Logger from "../services/Logger";

export class DumpStore {

    dumpUsers: SwipeUser[] = []
    likedUids: Set<string> = new Set()
    finalDumpUids: Set<string> = new Set()
    loadProg: ProgStatus = 'INIT'

    constructor() {
        makeAutoObservable(this)
    }

    fetchDumps() {
        this.loadProg = 'LOADING'
        ApiService.fetchDumpUsers({ sortOrder: 0 })
            .then(resp => {
                this.loadProg = 'SUCCESS'
                this.dumpUsers = resp.data.users
            })
            .catch(err=>{
                this.loadProg = 'FAILED'
            })
    }

    toggleLike(uid: string) {

        if(this.likedUids.has(uid))
         this.likedUids.delete(uid)
        else
         this.likedUids.add(uid)

        this.finalDumpUids.delete(uid)

        Logger.info(this.likedUids)

    }

    toggleDump(uid: string) {
       
        if(this.finalDumpUids.has(uid))
         this.finalDumpUids.delete(uid)
        else
         this.finalDumpUids.add(uid)
        
        this.likedUids.delete(uid)
    }

    confirmChoice() {
        ApiService.revertDumps({
            likedUids: Array.from(this.likedUids) ,
            unlikedUids: Array.from(this.finalDumpUids)
        }).then(resp =>{
            this.likedUids = new Set()
            this.finalDumpUids = new Set()
            this.dumpUsers = resp.data.dumps
        })
        .catch(err => Logger.err(err, 'REVERT_DUMP'))
    }


}